export function Filter(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
      }}
      className={props.className + ' filterIcon'}
    >
      <svg
        width="20"
        height="23"
        viewBox="0 0 20 23"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 0.200001H4.00005C2.23274 0.200001 0.800049 1.63269 0.800049 3.4V4.5265C0.800049 6.06976 1.48553 7.53328 2.67109 8.52125L6.5122 11.7222C6.69459 11.8742 6.80005 12.0993 6.80005 12.3368V18.4C6.80005 19.4072 7.27427 20.3557 8.08005 20.96L9.28005 21.86C9.70413 22.1781 10.2199 22.35 10.75 22.35C12.1031 22.35 13.2 21.2531 13.2 19.9V12.3368C13.2 12.0993 13.3055 11.8742 13.4879 11.7222L17.329 8.52125C18.5146 7.53328 19.2 6.06976 19.2 4.5265V3.4C19.2 1.63269 17.7674 0.200001 16 0.200001ZM4.00005 2.6H16C16.4419 2.6 16.8 2.95817 16.8 3.4V4.5265C16.8 5.35748 16.4309 6.14554 15.7926 6.67752L11.9515 9.87844C11.2219 10.4864 10.8 11.3871 10.8 12.3368V19.9C10.8 19.9276 10.7777 19.95 10.75 19.95C10.7392 19.95 10.7287 19.9465 10.72 19.94L9.52005 19.04C9.3186 18.8889 9.20005 18.6518 9.20005 18.4V12.3368C9.20005 11.3871 8.77822 10.4864 8.04864 9.87844L4.20753 6.67752C3.56915 6.14554 3.20005 5.35748 3.20005 4.5265V3.4C3.20005 2.95817 3.55822 2.6 4.00005 2.6Z"
          fill="currentColor"
          stroke="white"
        />
      </svg>
    </div>
  );
}
